import { render, staticRenderFns } from "./SvgaPlayer.vue?vue&type=template&id=10827c70&scoped=true&"
import script from "./SvgaPlayer.vue?vue&type=script&lang=js&"
export * from "./SvgaPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10827c70",
  null
  
)

export default component.exports